import React from "react";
import { Card, CardContent, Grid } from "@mui/material";
import { PageContainer } from "@packsize/components";

import { BackButton } from "./back-button";

interface DetailsContainerProps {
	readonly children: React.ReactNode;
	readonly HeaderActions?: React.ReactNode;
	readonly fillContent?: boolean;
}

export const DetailsContainer: React.FC<DetailsContainerProps> = ({ children, HeaderActions, fillContent = false }) => {
	return (
		<PageContainer sx={{ gap: 2, ...(fillContent && { minHeight: 0 }) }}>
			<Grid container gap={2} justifyContent="space-between">
				<BackButton />

				{HeaderActions ? (
					<Grid container gap={2}>
						{HeaderActions}
					</Grid>
				) : null}
			</Grid>

			<Card
				sx={
					fillContent
						? { flex: 1, minHeight: 0, overflow: "hidden", display: "flex", flexDirection: "column" }
						: { flex: 1, overflow: "auto" }
				}
			>
				<CardContent
					sx={
						fillContent
							? {
									flex: 1,
									minHeight: 0,
									overflow: "hidden",
									display: "flex",
									flexDirection: "column",
									"&:last-child": { pb: 2 },
								}
							: undefined
					}
				>
					{children}
				</CardContent>
			</Card>
		</PageContainer>
	);
};
